import { isRecord } from './data/contracts';

export type SearchResult = Record<string, unknown> & {
  hits: unknown[];
  nbHits: number;
};

function isSearchResult(value: unknown): value is SearchResult {
  return isRecord(value) && Array.isArray(value.hits)
    && typeof value.nbHits === 'number' && Number.isFinite(value.nbHits);
}

export function parseSearchResult(value: unknown): SearchResult {
  if (!isSearchResult(value)) throw new TypeError('Invalid search API response');
  return value;
}

export function parseFacetResult(value: unknown): Record<string, unknown>[] {
  if (!Array.isArray(value) || !value.every(isRecord)) {
    throw new TypeError('Invalid search facet response');
  }
  return value;
}
